var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-panel container-fluid"},[_c('div',{staticClass:"col-sm"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"id":"logo","src":require("../assets/pg-logo.png"),"alt":"Practigame"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c2df72","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 284
// module chunks = 0